import ProductCollectionWithCards from "@/components/ProductCollectionWithCards.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { strippedCta } from "@/helpers/builder-init/index";
const colors = ["None", ...Object.keys(themeColors)];
export const productCollectionWithCardsInit = {
    component: ProductCollectionWithCards,
    name: "LifestyleAndProducts",
    inputs: [
        {
            name: "eyebrow",
            friendlyName: "Eyebrow",
            type: "string",
            defaultValue: ""
        },
        {
            name: "eyebrowColor",
            friendlyName: "Eyebrow Color",
            helperText: "",
            type: "string",
            enum: colors
        },
        {
            name: "heading",
            type: "string",
            defaultValue: ""
        },
        {
            name: "headingColor",
            friendlyName: "Heading Color",
            helperText: "",
            type: "string",
            enum: colors
        },
        {
            name: "image",
            type: "file",
            allowedFileTypes: ["jpeg", "png", "gif", "svg"]
        },
        {
            name: "imageAlt",
            friendlyName: "Image Alt",
            type: "string",
        },
        {
            name: 'cta',
            friendlyNamer: "CTA",
            type: 'object',
            ...strippedCta([
                'aria_label',
                'label',
                'url',
                'style',
            ])
        },
        {
            name: "backgroundColor",
            friendlyName: "Background Color",
            helperText: "",
            type: "string",
            enum: colors
        },
        {
            name: "tag",
            friendlyName: "Tag",
            type: "string",
            defaultValue: ""
        },
        {
            name: "collapseToGrid",
            friendlyName: "Collapse Items to Grid on Mobile",
            type: "boolean",
            defaultValue: false
        }
    ]
};
